import useMediaQuery from 'hooks/useMediaQuery'
import React from 'react'
import ReactPaginate, { ReactPaginateProps } from 'react-paginate'
import { MOBILE_WIDTH } from 'utils/constants'

import { Container } from './styles'
import { Button } from 'new-components/atoms'
import { CircleArrowLeft, CircleArrowRight } from 'lucide-react'

function Pagination(props: ReactPaginateProps) {
  const isMobile = useMediaQuery(MOBILE_WIDTH)

  return (
    <Container className={props.containerClassName}>
      <ReactPaginate
        {...props}
        marginPagesDisplayed={isMobile ? 1 : 3}
        previousLabel={
          <Button unstyled disabled={props.forcePage === 0}>
            <CircleArrowLeft />
          </Button>
        }
        nextLabel={
          <Button unstyled disabled={props.forcePage === props.pageCount - 1}>
            <CircleArrowRight />
          </Button>
        }
      />
    </Container>
  )
}

export default Pagination
